/**
 * WordPress dependencies
 */
import { store } from '@wordpress/interactivity';

store('big-bite-stats-perform/match-lineups', {
  callbacks: {
    init() {},
  },
});
